/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Requirements_Radius_Need_PointInputs */

const cs_requirements_radius_need_point = /** @type {(inputs: Requirements_Radius_Need_PointInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nejdřív vyberte místo z návrhů, pak nastavte okruh.`)
};

const en_requirements_radius_need_point = /** @type {(inputs: Requirements_Radius_Need_PointInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a suggested place first, then set a radius.`)
};

/**
* | output |
* | --- |
* | "Pick a suggested place first, then set a radius." |
*
* @param {Requirements_Radius_Need_PointInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const requirements_radius_need_point = /** @type {((inputs?: Requirements_Radius_Need_PointInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Requirements_Radius_Need_PointInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_requirements_radius_need_point(inputs)
	return cs_requirements_radius_need_point(inputs)
});